import { React, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import '../../../translations/i18n';
import './style.less';

import { Modal } from 'antd';
import Form from 'antd/es/form';
import Input from 'antd/es/input';
import Button from 'antd/es/button';
import Select from 'antd/es/select';
import Checkbox from 'antd/es/checkbox';
import notification from 'antd/es/notification';

import { GetMeAction, OnboardingNow } from '../action';
import { GujaratCo, stateID, UserTypeDict } from '../../../utils/settings';
import { TermsAndConditions } from '../../../utils/termsAndConditions';
import {
  GetAllStates,
  GetAllCityOfState,
  GetAllCompanies,
  benifitCheckWithPincode,
  GstUserGstDataFetch,
  GstUserPanDataFetch,
  GstIndustries,
  GstDealerShipCompanyWithIndustryId,
  GetActiveCompaniesByDistrict,
} from '../action/util_actions';
import { checkingForOnlyErrorNotification } from '../../../utils/utilFuntions';
import { CancelationPolicy } from '../../../utils/CancelationPolicy';
import { PrivacyPolicy } from '../../../utils/PrivacyPolicy';
import { RefundPolicy } from '../../../utils/RefundPolicy';
import i18n from '../../../translations/i18n';

const { Option } = Select;
const IndustriesMaster = [
  {
    label: 'Building Contruction Materials',
    value: 'BCM',
  },
  {
    label: 'FMCG',
    value: 'FMCG',
  },
];
const fmcgStoreTypes = [
  {
    label: 'Self Service Shop',
    value: 'Self Service Shop',
  },
  {
    label: 'Kirana Shop',
    value: 'Kirana Shop',
  },
  {
    label: 'Wholesale Shop',
    value: 'Wholesale Shop',
  },
  {
    label: 'Bakery Shop',
    value: 'Bakery Shop',
  },
  {
    label: 'Diary Products Shop',
    value: 'Diary Products Shop',
  },
  {
    label: 'Non-Veg Speciality Shop',
    value: 'Non-Veg Speciality Shop',
  },
  {
    label: 'Chemist Shop',
    value: 'Chemist Shop',
  },
];
const Onboarding = (props) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const [companyType, setCompanyType] = useState();
  const [companies, setCompanies] = useState([]);
  const [industries, setIndustries] = useState([]);
  const [selectedIndustry, setSelectedIndustry] = useState(null);
  const [verifyModal, setVerifyModal] = useState(false);
  const [activeCompanies, setActiveCompanies] = useState([]);

  // States and city selection
  const [stateArr, setStateArr] = useState([]);
  const [currentStateId, setCurrentStateId] = useState(-1);
  const [currentDistrictId, setCurrentDistrictId] = useState(-1);
  const [industryType, setIndustryType] = useState();
  const [storeType, setStoreType] = useState();
  const [distArr, setDistArr] = useState([]);

  // User details Auropopulate
  const [userDetails, setUserDetails] = useState();
  const [userChecks, setUserChecks] = useState({
    firstname: null,
    lastname: null,
  });
  const [disableAddress, setDisableAddress] = useState(false);

  const [dropdownState, setDropdownState] = useState(false);

  const dispatch = useDispatch();
  const { loginUser } = useSelector((state) => {
    return {
      loginUser: state.loginReducer.loginUser,
    };
  });

  const [loader, setLoader] = useState(false);

  const [shownPolicy, setShownPolicy] = useState(0);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const policy = {
    0: TermsAndConditions,
    1: PrivacyPolicy,
    2: CancelationPolicy,
    3: RefundPolicy,
  };
  const policyTerms = {
    0: 'Terms And Conditions',
    1: 'Privacy Policy',
    2: 'Cancellation Policy',
    3: 'Refund Policy',
  };

  const modal = (
    <>
      <Modal
        centered
        title={policyTerms[shownPolicy]}
        onOk={() => setIsModalVisible(false)}
        onCancel={() => setIsModalVisible(false)}
        visible={isModalVisible}
        footer={null}
      >
        <div style={{ height: '60vh', overflow: 'scroll' }}>
          {policy[shownPolicy].map((item) => (
            <>
              <h3>{item.topic}</h3>
              {item.point}
              <br />
              <br />
            </>
          ))}
        </div>
      </Modal>
    </>
  );

  const modalForGujaratUser = (
    <>
      <Modal
        centered
        visible={verifyModal}
        onCancel={() => setVerifyModal(false)}
        footer={[
          <Button
            key='back'
            type='primary'
            onClick={() => setUser()}
          >
            Continue
          </Button>,
        ]}
      >
        <div style={{ width: '100%' }}>
          <div
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <img
              src='/humbee-logo-new.png'
              alt=''
              style={{
                height: '10rem',
                width: '10rem',
              }}
            />
          </div>
          <h2
            style={{
              fontWeight: 'bold',
              textAlign: 'center',
            }}
          >
            Attention User
          </h2>
          <h3>You are onboarded but humbee needs to verify your account</h3>
        </div>
      </Modal>
    </>
  );

  useEffect(() => {
    const GetAllStatesEffect = async () => {
      await GetAllStates().then((states) => {
        let { error, data } = states;
        if (!error && data) {
          setStateArr(data);
        }
      });
    };
    const getCompanies = async () => {
      let { error, data } = await GetAllCompanies({
        company_types: [UserTypeDict['CEMENT_COMPANY']],
      });
      if (!error) {
        setCompanies(data);
      }
    };
    const getActiveCompaniesByDistrict = async () => {
      let { error, data } = await GetActiveCompaniesByDistrict();
      if (!error) {
        setActiveCompanies(data);
      }
    };
    GetAllStatesEffect();
    getCompanies();
    getActiveCompaniesByDistrict();
  }, []);

  useEffect(() => {
    const GetAllCityOfStateEffect = async () => {
      if (currentStateId >= 0) {
        await GetAllCityOfState(currentStateId)
          .then((districts) => {
            setDistArr(districts);
            let { error, data } = districts;
            if (!error && data) {
              setDistArr(data);
            }
          })
          .catch();
      }
    };

    GetAllCityOfStateEffect();
  }, [currentStateId]);

  // useEffect(() => {
  //   getIndustries();
  // }, []);

  // useEffect(() => {
  //   const getCompanies = async () => {
  //     let { error, data } = await GstDealerShipCompanyWithIndustryId(
  //       selectedIndustry,
  //     );
  //     if (!error) {
  //       console.log('companies', data);
  //       setCompanies(data);
  //     }
  //   };

  //   if (selectedIndustry) getCompanies();
  // }, [selectedIndustry]);

  // useEffect(() => {
  //   if (!loginUser) {
  //     navigate('/login');
  //   }
  // }, [loginUser]);

  const handleStateChange = async (stateid) => {
    form.setFieldsValue({ city: null, companies: [] });
    const filteredID = stateID.filter((id) => id === currentStateId);

    if (filteredID.length > 0) {
      localStorage.setItem('language', 'en_state');
      i18n.changeLanguage('en_state');
      i18n.reloadResources();
    } else {
      localStorage.setItem('language', 'en_state');
      i18n.changeLanguage('en_state');
    }

    const item = stateArr.find((item) => {
      return item.id === stateid;
    });
    if (item) setCurrentStateId(item.id);
  };

  const handleIndustrySelection = (industry) => {
    setIndustryType(industry);
  };

  const handleDistrictChange = (distid) => {
    setCurrentDistrictId(distid);
  };

  const stateOptions =
    stateArr.length > 0
      ? stateArr.map((state) => ({ label: state.state_name, value: state.id }))
      : [];

  const districtOptions =
    distArr.length > 0
      ? distArr.map((district) => ({
          label: district.district_name,
          value: district.id,
        }))
      : [];

  const getStoreTypeOptions = () => {
    return fmcgStoreTypes.map((item) => {
      return (
        <Option
          key={item.id}
          value={item.id}
        >
          {item.name}
        </Option>
      );
    });
  };

  //Filtered UserType arr to only contain Retailer and Distributor
  const UserTypeArr = [
    { name: 'Retailer', id: 'Retailer', type: 3 },
    { name: 'Dealer', id: 'Dealer', type: 2 },
  ];

  const FMCGUserTypeArr = [
    { name: 'Distributor', id: 'Distributor', type: 2 },
    { name: 'Retailer', id: 'Retailer', type: 3 },
  ];

  const tempGujCompanyTypes = [
    { name: 'Dealer', id: 'Dealer', type: 3 },
    { name: 'Distributor', id: 'Distributor', type: 2 },
    { name: 'Associate', id: 'Associate', type: 8 },
  ];

  const typeOptions =
    industryType === 'FMCG'
      ? FMCGUserTypeArr.map((state) => (
          <Option
            key={state.id}
            value={state.id}
          >
            {state.name}
          </Option>
        ))
      : UserTypeArr.length > 0
      ? stateID.includes(currentStateId)
        ? tempGujCompanyTypes.map((state) => (
            <Option
              key={state.id}
              value={state.id}
            >
              {state.name}
            </Option>
          ))
        : UserTypeArr.map((state) => (
            <Option
              key={state.id}
              value={state.id}
            >
              {state.name}
            </Option>
          ))
      : [];

  const setUser = async () => {
    setVerifyModal(false);
    const { error: userError, data: loggedInUser } = await GetMeAction();

    if (!userError && loggedInUser) {
      dispatch({ type: 'SET_USER', data: loggedInUser });
      localStorage.setItem('user', JSON.stringify(loggedInUser));
      if (industryType === 'FMCG') {
        localStorage.setItem('isFMCG', true);
      } else {
        localStorage.setItem('isFMCG', false);
      }

      const filteredID = stateID.filter(
        (id) => id === loggedInUser.company_details.district_id.state.id,
      );
      if (filteredID.length > 0) {
        localStorage.setItem('language', 'en_state');
        i18n.changeLanguage('en_state');
        i18n.reloadResources();
      } else {
        localStorage.setItem('language', 'en_state');
        i18n.changeLanguage('en_state');
        i18n.reloadResources();
      }
      navigate('/');
    }
  };

  const onFinishHandler = async (value) => {
    if (!value['terms_condition']) {
      notification.error({
        message: 'Error',
        description: t('acceptTerms'),
      });
      return;
    }

    const district = distArr.find((item) => item.id === value.city);
    if (!district) {
      notification.error({
        message: 'Error',
        description: 'Select a district from Seleted State',
      });
      return;
    }

    const { user: phoneNo } = loginUser;
    const selectedCompaniesList = value.companies;

    const companyTypeNumber =
      industryType === 'FMCG'
        ? FMCGUserTypeArr.find((val) => val.name == value.company_type)?.type
        : stateID.includes(currentStateId)
        ? tempGujCompanyTypes.find((val) => val.name == value.company_type)
            ?.type
        : UserTypeArr.find((val) => val.name == value.company_type)?.type;

    const obj = {
      firstname: value.firstname,
      lastname: value.lastname,
      // role_id: +value.company_type,
      has_company: false,
      // company_id: 0,
      company_name: value.company_name,
      company_type: companyTypeNumber,
      company_gstin: value?.company_gstin?.toUpperCase(),
      company_phone_no: phoneNo,
      phone_number: phoneNo,
      // company_address: value.street1 + " " + value.street2,
      company_address: value.street,
      company_pincode: value.company_pincode,
      pancard_no: value.pancard_no.toUpperCase(),
      district_id: district.id,
      meta_data: {
        industry: [industryType],
        fssai: companyType === 'Distributor' ? value.fssai_no : null,
        shop_type: companyType === 'Retailer' ? value.store_type : null,
        supplier_companies: [...selectedCompaniesList],
      },
    };

    if (
      value.company_type === 'Dealer + Retailer' ||
      value.company_type === 'Distributor'
    ) {
      if (!selectedCompaniesList || selectedCompaniesList.length === 0) {
        notification.warning({
          message: t('noCompanySelected'),
        });
        return;
      }

      obj.cement_co_id = selectedCompaniesList;
    }

    setLoader(true);

    const { error, message, data } = await OnboardingNow(obj);

    setLoader(false);

    if (!error) {
      const isDistributor = obj.company_type === UserTypeDict['DISTRIBUTOR'];

      if (isDistributor) setVerifyModal(true);
      else {
        setUser();
      }
    } else {
      return notification.error({
        message: 'Error',
        description: message,
      });
    }
  };

  const skipAction = async () => {
    let { error: userError, data: loggedInUser } = await GetMeAction();

    if (!userError && loggedInUser) {
      dispatch({ type: 'SET_USER', data: loggedInUser });
      localStorage.setItem('user', JSON.stringify(loggedInUser));
      navigate('/');
    }
  };

  const companyTypeChange = (e) => {
    form.setFieldsValue({ companies: [] });

    setCompanyType(e);
  };

  const renderCompanies =
    activeCompanies[currentDistrictId] &&
    activeCompanies[currentDistrictId].length > 0 &&
    activeCompanies[currentDistrictId].map((company) => {
      return (
        <Option
          value={company.id}
          key={company.id}
          label={company.name}
        >
          {company.name}
        </Option>
      );
    });

  const getIndustries = async (e) => {
    const { error, message, data } = await GstIndustries();

    checkingForOnlyErrorNotification(error, message);

    if (!error && Object.keys(data).length) {
      console.log(data, 'industries data');
      setIndustries(data);
    }
  };

  const onPincodeBlur = async (e) => {
    if (e.target.value.length) {
      const { error, message, data } = await benifitCheckWithPincode(
        e.target.value,
      );

      if (data.is_benefits_enable) {
        notification.warning({
          message: t('onboarding.warning'),
          description: t(
            'onboarding.benefitsNotAvailableInYourAreaButStillYouCanContinue',
          ),
        });
        return;
      }
    }
  };

  const onGstBlur = async (e) => {
    if (form.getFieldValue('company_type') === 'Retailer') return;

    const value = e.target.value;
    let regex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/i;
    let findVal = regex.exec(value);
    if (findVal === null) {
      return;
    }

    const { error, message, data } = await GstUserGstDataFetch(value);

    checkingForOnlyErrorNotification(error, message);

    if (!error && Object.keys(data).length) {
      const firstName = data.directors
        ? Array.isArray(data?.directors) &&
          data.directors.length > 0 &&
          data?.directors[0]?.split(' ')[0]
        : null;

      const lastName = data.directors
        ? Array.isArray(data?.directors) &&
          data.directors.length > 0 &&
          data?.directors[0]?.trim().replace(/\s+/g, ' ').split(' ').length ===
            3
          ? data?.directors[0]?.trim().replace(/\s+/g, ' ').split(' ')[2]
          : data?.directors[0]?.trim().replace(/\s+/g, ' ').split(' ')[1]
        : null;

      setUserDetails(data);
      setUserChecks({ firstname: firstName, lastname: lastName });
      form.setFieldsValue({
        pancard_no: data?.pan,
        firstname: firstName,
        lastname: lastName,
        company_name: data?.trade_name,
        street: data?.principal_address?.address,
        company_pincode: data?.principal_address?.pincode,
      });

      if (data?.principal_address?.address) {
        setDisableAddress(true);
      }
    }
  };

  const onPanBlur = async (e) => {
    if (
      form.getFieldValue('company_type') === 'Retailer' ||
      (companyType === 'Dealer' && stateID.includes(currentStateId))
    ) {
      const value = e.target.value;
      let regex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/i;
      let findVal = regex.exec(value);
      if (findVal === null) {
        return;
      }

      const { error, message, data } = await GstUserPanDataFetch(value);

      checkingForOnlyErrorNotification(error, message);
      // return;

      if (!error) {
        const firstName = data?.first_name && data?.first_name;
        const lastName = data?.last_name && data?.last_name;

        // data.directors = {};
        setUserDetails(data);
        setUserChecks({ firstname: firstName, lastname: lastName });

        form.setFieldsValue({
          firstname: firstName,
          lastname: lastName,
          company_pincode:
            data?.address_data &&
            data?.address_data?.pincode &&
            data?.address_data?.pincode,
          street:
            data?.address_data &&
            data?.address_data?.line_1 &&
            data?.address_data?.line_1,
        });

        if (
          data?.address_data &&
          data?.address_data?.line_1 &&
          data?.address_data?.line_1
        ) {
          setDisableAddress(true);
        }
      }
    }
  };

  const gstMandatory = companyType === 'Dealer' || companyType === 'Retailer';

  return (
    <div className={'onboarding newChange'}>
      <div className={'onboarding-container'}>
        {/* <Button
          onClick={() => skipAction()}
          block={false}
          className={'skipBtn'}
          type="primary"
        >
          <b className={'btnText'}>Skip</b>
          <ArrowRightOutlined className={'btnArrow'} />
        </Button> */}
        <div className={'onboarding-header'}>
          <div className={'welcome-text'}>{t('onboarding.nowUAre')}</div>
          <div className={'screen-title'}>{t('onboarding.onboarding')}</div>
        </div>

        <Form
          form={form}
          layout={'vertical'}
          name={'onboarding'}
          autoComplete='off'
          onFinish={onFinishHandler}
        >
          {/* Industry Filter*/}
          <Form.Item
            label={'Select Industry'}
            name='industry'
            rules={[
              { required: true, message: 'Industry filter is mandatory.' },
            ]}
            // style={{ display: 'inline-block', width: 'calc(50% - 8px)' }}
          >
            <Select
              showSearch
              placeholder={'Select Industry'}
              onChange={handleIndustrySelection}
              id='industry_select'
              filterOption={(input, option) =>
                (option?.label ?? '')
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              options={IndustriesMaster}
            />
          </Form.Item>
          {industryType && (
            <>
              {/* State */}
              <Form.Item
                label={t('onboarding.state')}
                name='state'
                rules={[{ required: true, message: 'State is mandatory' }]}
                // style={{ display: 'inline-block', width: 'calc(50% - 8px)' }}
              >
                <Select
                  showSearch
                  placeholder={t('onboarding.state')}
                  onChange={handleStateChange}
                  id='state_select'
                  filterOption={(input, option) =>
                    (option?.label ?? '')
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={stateOptions}
                />
              </Form.Item>

              {/* City */}
              <Form.Item
                label={t('onboarding.city')}
                name='city'
                rules={[{ required: true, message: 'District is Mandatory' }]}
              >
                <Select
                  placeholder={t('onboarding.city')}
                  onChange={handleDistrictChange}
                  id='city_select'
                  filterOption={(input, option) =>
                    (option?.label ?? '')
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={districtOptions}
                  showSearch
                />
              </Form.Item>

              {/* Registered As */}
              <Form.Item
                label={t('onboarding.registeredAs')}
                name={'company_type'}
                rules={[
                  {
                    required: true,
                    message: t('onboarding.noRegisteredAs'),
                  },
                ]}
              >
                <Select
                  placeholder={t('userType.RETAILER')}
                  className={'registerSelector'}
                  id='company_type_select'
                  onChange={companyTypeChange}
                >
                  {typeOptions}
                </Select>
              </Form.Item>
              {/* select DealerShip Company */}
              <Form.Item
                name='companies'
                label={'Select Registered Companies'}
                rules={[
                  {
                    required: companyType === 'Retailer' ? false : true,
                    message: 'Please select a company!',
                  },
                ]}
              >
                <Select
                  mode='multiple'
                  open={dropdownState}
                  onClick={() => setDropdownState(!dropdownState)}
                  onChange={(e) => console.log(e)}
                  allowClear
                  id='company_select'
                  style={{ width: '100%' }}
                  placeholder={'Select Registered Companies'}
                  optionFilterProp={'label'}
                >
                  {renderCompanies}
                </Select>
              </Form.Item>

              {/* FSSAI License */}
              {companyType === 'Distributor' && industryType === 'FMCG' && (
                <Form.Item
                  label={'FSSAI License Number'}
                  name={'fssai_no'}
                  rules={[
                    {
                      required: true,
                      message: 'FSSAI License Number is required',
                    },
                  ]}
                >
                  <Input
                    id='fssai_no_input'
                    placeholder={'FSSAI License Number'}
                  />
                </Form.Item>
              )}

              {/* Type of store */}
              {companyType === 'Retailer' && industryType === 'FMCG' && (
                <Form.Item
                  label={'Select type of store'}
                  name={'store_type'}
                  rules={[
                    {
                      required: true,
                      message: 'Type of store',
                    },
                  ]}
                >
                  <Select
                    placeholder={'Select type of store'}
                    className={'storeType'}
                    id='store_type'
                    options={fmcgStoreTypes}
                  />
                </Form.Item>
              )}

              {/* Gst no. */}
              <Form.Item
                label={t('onboarding.gstNo')}
                name={'company_gstin'}
                rules={[
                  {
                    required: gstMandatory ? false : true,
                    message: t('onboarding.noGstNo'),
                  },
                  gstMandatory
                    ? {}
                    : {
                        validator(_, value) {
                          if (!value) {
                            return Promise.reject('GST number is mandatory');
                          }
                          if (value.length === 15) {
                            let regex =
                              /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/i;
                            let findVal = regex.exec(value);
                            if (findVal === null) {
                              return Promise.reject('Wrong GST input');
                            }
                            if (findVal.input) {
                              return Promise.resolve();
                            }
                          } else {
                            return Promise.reject(
                              'GST number should be of 15 digit',
                            );
                          }
                        },
                      },
                ]}
              >
                <Input
                  onBlur={onGstBlur}
                  id='gst_no_input'
                  placeholder={t('onboarding.pleaseGstDetails')}
                ></Input>
              </Form.Item>

              {/* Pan No. */}
              <Form.Item
                label={t('onboarding.panNo')}
                name={'pancard_no'}
                rules={[
                  {
                    required: true,
                    message: t('onboarding.noPanNo'),
                  },
                  {
                    validator(_, value) {
                      if (!value) {
                        return Promise.reject('PAN number is mandatory');
                      }
                      if (value.length === 10) {
                        let regex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/i;
                        let findVal = regex.exec(value);
                        if (findVal === null) {
                          return Promise.reject('Wrong PAN Number Input');
                        }
                        if (findVal.input) {
                          return Promise.resolve();
                        }
                      } else {
                        return Promise.reject(
                          'PAN number should be of 10 digit',
                        );
                      }
                    },
                  },
                ]}
              >
                <Input
                  onBlur={onPanBlur}
                  id='pan_no_input'
                  placeholder={t('onboarding.pleasePanDetails')}
                ></Input>
              </Form.Item>

              {/* First Name */}
              <Form.Item
                label={t('onboarding.firstName')}
                name={'firstname'}
                rules={[
                  {
                    required: true,
                    message: t('onboarding.noName'),
                  },
                ]}
              >
                <Input
                  disabled={userChecks.firstname ? true : false}
                  id='first_name_input'
                  placeholder={t('onboarding.firstName')}
                ></Input>
              </Form.Item>

              {/* Last Name */}
              <Form.Item
                label={t('onboarding.lastName')}
                name={'lastname'}
                rules={[
                  {
                    required: true,
                    message: t('onboarding.noLastName'),
                  },
                ]}
              >
                <Input
                  disabled={userChecks.lastname ? true : false}
                  id='last_name_input'
                  placeholder={t('onboarding.lastName')}
                ></Input>
              </Form.Item>

              {/* Your Company Name */}
              <Form.Item
                label={t('onboarding.yourCompanyName')}
                name={'company_name'}
                rules={[
                  {
                    required: true,
                    message: t('onboarding.noCompanyName'),
                  },
                ]}
              >
                <Input
                  disabled={userDetails?.trade_name}
                  id='company_name_input'
                  placeholder={t('onboarding.companyName')}
                ></Input>
              </Form.Item>

              {/* DealerShip companies */}
              {/* {companyType === "Dealer + Retailer" ||
              companyType === "Distributor" || companyType === "Retailer" ? (
                <>
                  {/* <Form.Item
                name='industry'
                label={'Select Industry'}
                rules={[
                  {
                    required: companyType === 'Retailer' ? false : true,
                    message: 'Please select a Industry!',
                  },
                ]}
              >
                <Select
                  onChange={(e) => {
                    setSelectedIndustry(e);
                  }}
                  allowClear
                  style={{ width: '100%' }}
                  placeholder={'Please select a Industry'}
                >
                  {industriesOptions}
                </Select>
              </Form.Item> */}

              {/* </>
              ) : (
                ""
              )} */}
              {/* Enabled company selection for all users. */}

              {/* <Form.Item
          label={t("onboarding.companyPhoneNo")}
          name={"company_phone_no"}
          rules={[
            {
              message: t("onboarding.noCompanyPhoneNo"),
            },
          ]}
        >
          <Input
            maxLength={10}
            minLength={10}
            placeholder={t("onboarding.companySupportNumber")}
          ></Input>
        </Form.Item> */}

              {/* Street Address */}
              <div className={'otpContainer__onboarding  '}>
                <Form.Item
                  name='street'
                  label={t('address')}
                  style={{ flex: 1, margin: 0, marginBottom: '1rem' }}
                  rules={[{ required: true, message: 'Enter Street Address' }]}
                >
                  <Input
                    disabled={disableAddress}
                    id='address_input'
                    placeholder={t('onboarding.streetAddress1')}
                  />
                </Form.Item>
                {disableAddress && (
                  <div className={'resendText-onboarding'}>
                    <p
                      onClick={() => setDisableAddress(false)}
                      className='send_otp'
                      style={{
                        border: 'none',
                        backgroundColor: disableAddress ? '#F49D3F' : 'gray',
                      }}
                    >
                      Change
                    </p>
                  </div>
                )}
              </div>

              {/* Company Pincode */}
              <Form.Item
                name='company_pincode'
                label={t('pincode')}
                rules={[{ required: true, message: 'Enter Company Pincode' }]}
              >
                <Input
                  disabled={
                    userDetails?.address_data &&
                    userDetails?.address_data?.pincode
                  }
                  placeholder={t('onboarding.postalCode')}
                  maxLength={6}
                  minLength={6}
                  inputMode={'numeric'}
                  onBlur={onPincodeBlur}
                  id='pincode_input'
                  onKeyPress={(e) => {
                    const key = e.key;
                    if (
                      (key !== '.' && isNaN(key)) ||
                      (key === '.' && e.target.value.includes('.'))
                    ) {
                      e.preventDefault();
                    }
                  }}
                />
              </Form.Item>

              {/* Terms And Condition */}
              <Form.Item
                name='terms_condition'
                rules={[
                  { required: true, message: 'Agree Terms & Conditions' },
                ]}
                valuePropName='checked'
              >
                <Checkbox
                  className={'onboardingCheckbox'}
                  id='terms_condition_check'
                >
                  {t('onboarding.accept')}{' '}
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a
                    onClick={() => {
                      setIsModalVisible(true);
                      setShownPolicy(0);
                    }}
                  >
                    {t('onboarding.conditions')},
                  </a>{' '}
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a
                    onClick={() => {
                      setIsModalVisible(true);
                      setShownPolicy(1);
                    }}
                  >
                    Privacy Policy,
                  </a>{' '}
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a
                    onClick={() => {
                      setIsModalVisible(true);
                      setShownPolicy(2);
                    }}
                  >
                    Cancellation Policy,
                  </a>{' '}
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a
                    onClick={() => {
                      setIsModalVisible(true);
                      setShownPolicy(3);
                    }}
                  >
                    Refund Policy
                  </a>
                </Checkbox>
              </Form.Item>

              {/* Verify Botton */}
              <Form.Item>
                <Button
                  loading={loader}
                  block={true}
                  className={'btn'}
                  type='primary'
                  htmlType='submit'
                  id='onboarding_submit_btn'
                >
                  <b className={'btnText'}>{t('onboarding.verify')}</b>
                </Button>
              </Form.Item>

              {modal}
              {modalForGujaratUser}
            </>
          )}
        </Form>
      </div>
    </div>
  );
};

export default Onboarding;
